/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_2Inputs */

const en_mk_proof_2 = /** @type {(inputs: Mk_Proof_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep task verify runs them on your machine: tests, build, file checks, screenshots.`)
};

const id_mk_proof_2 = /** @type {(inputs: Mk_Proof_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep task verify menjalankannya di mesinmu: test, build, cek berkas, tangkapan layar.`)
};

/**
* | output |
* | --- |
* | "bystep task verify runs them on your machine: tests, build, file checks, screenshots." |
*
* @param {Mk_Proof_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_2 = /** @type {((inputs?: Mk_Proof_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_2(inputs)
	return en_mk_proof_2(inputs)
});